import { SUPPORT_FEATURE } from "api/ApiPath";
import client from "api/client";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IApiDocumentRepository } from "features/apiDocumentFeature/domain/repositories/IApiDocumentRepository";
import { injectable } from "tsyringe";
import { ApiDocumentRequestModel } from "./model/ApiDocumentRequestModel";
import { ApiDocumentResponseModel } from "./model/ApiDocumentResponseModel";
import { CreateFileRequestEntity } from "../domain/entities/CreateFileRequestEntity";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ApiDocumentResponseEntity } from "../domain/entities/ApiDocumentResponseEntity";

import { DeleteFileRequestModel } from "./model/DeleteFileRequestModel";

@injectable()
export class ApiDocumentImpl implements IApiDocumentRepository {
  async getDocuments(
    params: ApiDocumentRequestModel
  ): Promise<ListBaseApiResponseModel<ApiDocumentResponseModel>> {
    return await client.get(SUPPORT_FEATURE.API_DOCUMENT, params);
  }

  async createFile(
    params: CreateFileRequestEntity
  ): Promise<BaseApiResponseModel<ApiDocumentResponseEntity>> {
    const formData = new FormData();
    if (params?.service) formData.append("service", params?.service);
    if (params?.type !== undefined) formData.append("type", params?.type?.toString());
    if (params?.folderPath) formData.append("folderPath", params?.folderPath);
    if (params?.isPrivate !== undefined) formData.append("isPrivate", params?.isPrivate?.toString());
    if (params?.fileField) formData.append("fileField", params?.fileField);
    if (params?.order !== undefined) formData.append("order", params?.order?.toString());
    if (params?.file) formData.append("file", params?.file, params?.file?.name);

    return await client.post(SUPPORT_FEATURE.UPLOAD_FILE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async deleteFile(
    params: DeleteFileRequestModel
  ): Promise<BaseApiResponseModel<unknown>> {
    return await client.delete(SUPPORT_FEATURE.DELETE_FILE, params);
  }
}
